var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSavingBank = function SvgSavingBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "saving-bank"), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.5,
    y1: 23.25,
    x2: 22.5,
    y2: 23.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.5,8.25H1.5l9.689-5.762a1.5,1.5,0,0,1,1.622,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "21 11.25 21 20.25 18 20.25 18 11.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "13.5 11.25 13.5 20.25 10.5 20.25 10.5 11.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "6 11.25 6 20.25 3 20.25 3 11.25"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSavingBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "saving-bank.3565e7f5e4716092e1d80c9618473283.svg";